// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__BKvYg","title":"Info_title__2icBt","selects":"Info_selects__1Jo3w","requiredAsterisk":"Info_requiredAsterisk__egF1T"};